var map = {
	"./TCL.png": "YKa+",
	"./changhong.png": "r+XV",
	"./hisense.png": "aQtq",
	"./huawei.png": "zMma",
	"./konka.png": "u7nY",
	"./letv.png": "tKWf",
	"./mi.png": "ltzv",
	"./skyworth.png": "pqUk",
	"./skyworthBox.png": "tqMu",
	"./sony.png": "Rdw7",
	"./tianmao.png": "WhGq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "snDL";